import { BAOCustomElement } from '@bao/custom-element'
import { Cart } from '@bao/cart'
import { sectionRenderer } from '@bao/section-rendering'

const FINISHING_TOUCHES_LIST = 'Finishing touches'

class ProductCardForm extends BAOCustomElement() {
  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? sectionRenderer.pushCartSections
      : this.onCartPage
        ? sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.handleFormSubmit.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(
        `needs to be wrapped around a product card's <form> element`,
      )
    }
  }

  async handleFormSubmit (event) {
    event.preventDefault()
    await this.addToCart()
  }

  async addToCart () {
    const state = await Cart.addItemFromForm(this.form, {
      sections: this.mappedSections,
    })

    if (state && this.inFinishingTouches) {
      this.trackFinishingTouchesAdd(state)
    }

    return state
  }

  trackFinishingTouchesAdd (item) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'finishing_touches_add',
      ecommerce: {
        currencyCode: window.Shopify?.currency?.active,
        add: {
          actionField: { list: FINISHING_TOUCHES_LIST },
          products: [
            {
              id: item.sku,
              name: item.product_title,
              brand: item.vendor,
              category: item.product_type,
              variant: item.variant_title,
              price: (item.price / 100).toFixed(2),
              quantity: String(item.quantity),
              list: FINISHING_TOUCHES_LIST,
              product_id: String(item.product_id),
              variant_id: String(item.variant_id),
              image: item.image,
              url: `${window.location.origin}${item.url}`,
            },
          ],
        },
      },
    })
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  get inFinishingTouches () {
    return this.closest('.blk-CartRecommendations') !== null
  }

  get inPushCart () {
    return document.body.dataset.pageType !== 'cart'
  }

  get onCartPage () {
    return document.body.dataset.pageType === 'cart'
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }
}

if (!customElements.get('product-card-form')) {
  customElements.define('product-card-form', ProductCardForm)
}
